export default "__VITE_ASSET__3918608b__"